export interface EnquiryPayload {
  fullName?: string;
  name?: string;
  email: string;
  phone: string;
  destination?: string;
  nationality?: string;
  travelDate?: string;
  numberOfDays?: number;
  numberOfTravellers?: number;
  budget?: number;
  subject?: string;
  message?: string;
  note?: string;
  leadType?: string;
  source: string;
  sourcePage: string;
  leadCountry: string;
  country: string;
  pagePath: string;
  pageUrl: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
}

interface EnquiryResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

const normalizeBaseUrl = (value: string) => {
  const trimmed = value.replace(/\/+$/, "");

  if (!trimmed) {
    return "http://20.5.50.240:3000";
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

const rawBaseUrlCandidates = [
  // import.meta.env.VITE_API_BASE_URL?.toString().trim(),
  import.meta.env.VITE_API_BASE_URL?.toString().trim(),
 
].filter((value): value is string => Boolean(value && value.trim()));

const API_BASE_URL_CANDIDATES = Array.from(
  new Set(rawBaseUrlCandidates.map((value) => normalizeBaseUrl(value))),
);
const ENQUIRY_CAPTURE_ENDPOINT = "/api/website-enquiries/capture";

export const submitEnquiry = async (payload: EnquiryPayload): Promise<EnquiryResponse> => {
  let lastFailure: EnquiryResponse = {
    success: false,
    message: "Network error. Please try again.",
  };

  for (const apiBaseUrl of API_BASE_URL_CANDIDATES) {
    try {
      const response = await fetch(`${apiBaseUrl}${ENQUIRY_CAPTURE_ENDPOINT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const contentType = (response.headers.get("content-type") || "").toLowerCase();
      let data: unknown;
      let message = "";

      if (contentType.includes("application/json")) {
        data = await response.json();
        const parsed = data as {
          message?: string;
          error?: { message?: string; requestId?: string };
          requestId?: string;
        };
        const requestId = parsed.error?.requestId || parsed.requestId || "";
        const baseMessage = parsed.error?.message || parsed.message || "";
        message = requestId ? `${baseMessage} (Request ID: ${requestId})` : baseMessage;
      } else if (response.status !== 204) {
        message = (await response.text()).trim();
      }

      if (contentType.includes("text/html")) {
        lastFailure = {
          success: false,
          message:
            "Unable to reach enquiry API. Configure VITE_CRM_BASE_URL or VITE_API_BASE_URL correctly.",
        };
        continue;
      }

      if (response.ok) {
        return { success: true, data, message };
      }

      const currentFailure: EnquiryResponse = {
        success: false,
        message: message || `Failed to submit enquiry (${response.status})`,
        data,
      };

      if ([400, 401, 403, 409, 422].includes(response.status)) {
        return currentFailure;
      }

      lastFailure = currentFailure;
    } catch (error) {
      console.error("Enquiry submission error:", error);
      lastFailure = { success: false, message: "Network error. Please try again." };
    }
  }

  return lastFailure;
};
